import React from 'react';
import { IListItem } from '@nkr/models/list-item';
import { Button, FormControl, Row, Well } from 'react-bootstrap';

interface IProps {
    statusFilter: number,
    bulkUpdate: {
        action: string,
        reason: number
    },
    disableBulkUpdate: boolean,
    donorPreselectReviewStatusList: IListItem[],
    onStatusFilterChange: (statusFilter: number) => void,
    onBulkUpdateActionChange: (action: string) => void,
    onBulkUpdateReasonChange: (reason: number) => void,
    onConfirmBulkUpdate: () => void
}

const BulkActions = ({ statusFilter, bulkUpdate, disableBulkUpdate, donorPreselectReviewStatusList,
    onStatusFilterChange, onBulkUpdateActionChange, onBulkUpdateReasonChange, onConfirmBulkUpdate }: IProps) => {
    const handleStatusFilterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        onStatusFilterChange(parseInt(e.currentTarget.value));
    };

    const handleBulkUpdateActionChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        onBulkUpdateActionChange(e.currentTarget.value);
    };

    const handleBulkUpdateReasonChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        onBulkUpdateReasonChange(parseInt(e.currentTarget.value));
    };

    return (
        <div style={{ marginBottom: 10, paddingLeft: 0, paddingRight: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <div style={{ whiteSpace: 'nowrap' }}>Filter&nbsp;by&nbsp;Review&nbsp;Status:</div>
                <FormControl
                    componentClass='select'
                    style={{ width: 'initial' }}
                    value={statusFilter}
                    onChange={handleStatusFilterChange}
                >
                    <option value={-1}>- All -</option>
                    {donorPreselectReviewStatusList.map(item =>
                        <option key={'review-status-' + item.id} value={item.id}>{item.description}</option>
                    )}
                </FormControl>
            </div>

            <Well bsSize='small' style={{ margin: 0 }}>
                <Row>
                    <div
                        title='Paired Donor for Recipient.'
                        style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginRight: 30 }}
                    >
                        <div
                            style={{
                                height: 20,
                                width: 60,
                                backgroundColor: '#006401',
                                border: '1px solid #ddd',
                                marginRight: 5,
                                borderRadius: 4
                            }}
                        />
                        <div>Paired donor of the recipient</div>
                    </div>
                </Row>
            </Well>

            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <FormControl
                    componentClass='select'
                    value={bulkUpdate.action}
                    onChange={handleBulkUpdateActionChange}
                >
                    <option value=''>- Select Bulk Update Option -</option>
                    <option value='decline'>Decline - Not Acceptable</option>
                    <option value='review'>Review</option>
                </FormControl>

                {bulkUpdate.action == 'review' && (
                    <FormControl
                        componentClass='select'
                        value={bulkUpdate.reason}
                        onChange={handleBulkUpdateReasonChange}
                    >
                        <option value={-1}>- Select Review Status -</option>
                        <option value={null}>- Remove Assigned Status -</option>
                        {donorPreselectReviewStatusList.map(item =>
                            <option key={'review-reason-' + item.id} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>
                )}

                <Button bsStyle='primary' disabled={disableBulkUpdate} onClick={onConfirmBulkUpdate}>
                    Update Checked
                </Button>
            </div>
        </div>
    );
}

export default BulkActions;